"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Practitioner = exports.PractitionerGenderKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_HumanName_1 = require("./RTTI_HumanName");
var RTTI_ContactPoint_1 = require("./RTTI_ContactPoint");
var RTTI_Address_1 = require("./RTTI_Address");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_Attachment_1 = require("./RTTI_Attachment");
var RTTI_Practitioner_Qualification_1 = require("./RTTI_Practitioner_Qualification");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var PractitionerGenderKind;
(function (PractitionerGenderKind) {
    PractitionerGenderKind["_male"] = "male";
    PractitionerGenderKind["_female"] = "female";
    PractitionerGenderKind["_other"] = "other";
    PractitionerGenderKind["_unknown"] = "unknown";
})(PractitionerGenderKind = exports.PractitionerGenderKind || (exports.PractitionerGenderKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Practitioner = t.recursion('IPractitioner', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Practitioner')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            active: t.boolean,
            _active: RTTI_Element_1.RTTI_Element,
            name: t.array(RTTI_HumanName_1.RTTI_HumanName),
            telecom: t.array(RTTI_ContactPoint_1.RTTI_ContactPoint),
            address: t.array(RTTI_Address_1.RTTI_Address),
            gender: (0, EnumType_1.createEnumType)(PractitionerGenderKind, 'PractitionerGenderKind'),
            _gender: RTTI_Element_1.RTTI_Element,
            birthDate: RTTI_date_1.RTTI_date,
            _birthDate: RTTI_Element_1.RTTI_Element,
            photo: t.array(RTTI_Attachment_1.RTTI_Attachment),
            qualification: t.array(RTTI_Practitioner_Qualification_1.RTTI_Practitioner_Qualification),
            communication: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept)
        })
    ]);
});
//# sourceMappingURL=RTTI_Practitioner.js.map